import React from 'react';
import { Route, RouteComponentProps, Switch } from 'react-router';

import { CourseList } from './CourseList';
import { LessonList } from './LessonList';
import { SpeechDetail } from './SpeechDetail';

export const Course = (props: RouteComponentProps) => (
  <Switch>
    <Route path={`${props.match.path}/list`} component={CourseList} />;
    <Route path={`${props.match.path}/:courseId/lesson/:lessonId/speechDetail`} component={SpeechDetail} />
    ;
    <Route path={`${props.match.path}/:courseId/lesson`} component={LessonList} />;
  </Switch>
);



// WEBPACK FOOTER //
// ./src/screens/course/Course.tsx